import { create } from 'zustand';
import type { ProjectViewPrefs, ProjectId } from '@vd/types';
import { api } from '../../lib/api';

interface BoardPrefsState {
  prefsByProject: Record<string, ProjectViewPrefs>;
  get: (projectId: ProjectId) => ProjectViewPrefs;
  patch: (projectId: ProjectId, patch: Partial<ProjectViewPrefs>) => void;
}

export const useBoardPrefs = create<BoardPrefsState>((set, getStore) => ({
  prefsByProject: {},
  get(projectId) {
    const cached = getStore().prefsByProject[projectId];
    if (cached) return cached;
    const initial = api.getPrefs(projectId);
    set((s) => ({ prefsByProject: { ...s.prefsByProject, [projectId]: initial } }));
    return initial;
  },
  patch(projectId, patch) {
    set((s) => {
      const next = { ...(s.prefsByProject[projectId] ?? api.getPrefs(projectId)), ...patch };
      api.setPrefs(projectId, patch);
      return { prefsByProject: { ...s.prefsByProject, [projectId]: next } };
    });
  },
}));
